import React, { useState } from "react";
import { Table } from "antd";

const NsfdcTable = ({ data }) => {
  const userGroup = sessionStorage.getItem("userGroup");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (paginationConfig) => {
    setPagination(paginationConfig);
  };

  const columns = [
    { title: "Sr. No.", dataIndex: "srNo", key: "srNo" },
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Applicant Name", dataIndex: "name", key: "name" },
    {
      title: "Contact No.",
      dataIndex: "contact",
      key: "contact",
      render: (text) => {
        return text ? text.replace(/\d(?=\d{4})/g, "*") : "-";
      },
    },
    {
      title: "Loan Amount Requested",
      dataIndex: "loanAmount",
      key: "loanAmount",
    },
    { title: "Caste Name", dataIndex: "caste", key: "caste" },
    { title: "Income", dataIndex: "income", key: "income" },
    { title: "Aadhar Card No.", dataIndex: "aadhar", key: "aadhar" },
  ];

  const privilegedGroups = [
    "regionalManager",
    "MPBCDCOfficeAdmin",
    "MahaPreitOfficeAdmin",
    "districtManager",
    "MPBCDC_MD",
  ];

  const visibleColumns = privilegedGroups.includes(userGroup)
    ? columns.map((col) => col.key)
    : ["srNo", "id", "name"];

  const filteredColumns = columns.filter((col) =>
    visibleColumns.includes(col.key)
  );

  return (
    <Table
      dataSource={data}
      columns={filteredColumns}
      rowKey="id"
      pagination={{
        current: pagination.current,
        pageSize: pagination.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      style={{ marginTop: "20px" }}
    />
  );
};

export default NsfdcTable;
